// NPM Imports
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-responsive-modal";
import { Input, Button, Label, Toastr } from "../../revvComponents";

// Components Imports

// Actions Imports
import { forceUpdateEditorSectionIdAction } from "../../actions/DocumentActions/index";

// Services Imports

// Internal Imports

// Declarations
const _isBase64 = imageString => {
  if (
    typeof imageString === "string" &&
    (imageString.startsWith("data") ||
      (imageString.startsWith("<") && imageString.includes("<img ")))
  ) {
    return true;
  }
  return false;
};

export default function CustomImageAltTextPopup({
  closePopup,
  section,
  updateComponent,
}) {
  // Local state keys
  const [oldAltTextValue, updateOldAltText] = useState("");
  const [altTextValue, updateAltText] = useState("");

  // mapDispatchToPro
  const dispatch = useDispatch();

  const _saveAltText = () => {
    if (altTextValue && oldAltTextValue !== altTextValue) {
      const newSection = { ...section };
      if (_isBase64(newSection.data)) {
        newSection.data = JSON.stringify({
          image: newSection.data,
          altText: altTextValue,
        });
      } else {
        try {
          let newImageData = JSON.parse(newSection.data);
          newImageData = { ...newImageData, altText: altTextValue };
          newSection.data = JSON.stringify(newImageData);
        } catch (e) {
          console.error(`DocumentItems => _saveAltText => Error : ${e}`);
        }
      }

      updateComponent(newSection, true, false, section);
      dispatch(forceUpdateEditorSectionIdAction(newSection.id)); // need to re-render the custom image

      const message = oldAltTextValue
        ? "Alt-text has been updated successfully"
        : "Alt-text has been added successfully";
      Toastr.showToastr({
        className: "is-success",
        message,
        timeout: 2000,
      });
      closePopup();
    }
  };

  const _handleKeyDown = e => {
    if (e.key === "Enter" && altTextValue) {
      _saveAltText();
    }
  };

  const _handleInputChange = e => {
    updateAltText(e.target.value);
  };

  // CDM
  useEffect(() => {
    if (section && section.data && !_isBase64(section.data)) {
      const imageData = JSON.parse(section.data);
      updateAltText(imageData ? imageData.altText : "");
      updateOldAltText(imageData ? imageData.altText : "");
    }
  }, [section]);

  return (
    <Modal open onClose={closePopup} center>
      <div className="inviteteammatespopup-wrapper">
        <div className="inviteteammatespopup-modal-heading">
          Add alt-text for your image
        </div>

        <div className="inviteteammatespopup-description-section">
          <span className="inviteteammatespopup-description-text">
            All text is an alternative text that gets rendered if your image
            does not load. It also improves web accessibility and searchability
            of documents, if you post them on public web platforms.
          </span>
        </div>

        <div className="inviteteammatespopup-form">
          <div className="form-group">
            <Label htmlFor="userEmail">Alt-text</Label>
            <div className="inviteteammatespopup-copyblock">
              <Input
                data-test="alt-text-input-box"
                onChange={_handleInputChange}
                onKeyDown={_handleKeyDown}
                className="alt-text-input"
                type="text"
                placeholder="Enter description"
                value={altTextValue}
                autoFocus
              />
            </div>
          </div>
        </div>
      </div>
      <div className="createquotepopup-footer popup-footer">
        <div className="footer-actions">
          <Button
            data-test="alt-text-cancel-button"
            className="btn btn-transparent createquotepopup-footer-cancelbtn"
            onClick={closePopup}>
            Cancel
          </Button>
          <Button
            disabled={!altTextValue || oldAltTextValue === altTextValue}
            onClick={_saveAltText}
            data-test="alt-text-save-button"
            className="btn btn-primary">
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}
